import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import React, { Component, Fragment } from 'react';
import { lodash as _, constants, domain } from '../../../common';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import SweetAlert from '../../../components/feedback/SweetAlert';
import FieldDataSourceEditor from '../../../components/forms/FieldPropertyEditor/components/FieldDataSourceEditor';
import DataSourceRulesEditor from '../../../components/forms/FieldPropertyEditor/components/DataSourceRulesEditor';
import RepeatTimesSelector from '../../../components/forms/FieldPropertyEditor/components/RepeatTimesSelector';
import {
   applyEntryModeChange,
   applyRepeaterTypeChange,
   applyRequiresChange,
   canUseFullList as canUseFullListForOptions,
   repairAsFreeFlow
} from '../../../components/forms/FieldPropertyEditor/repeaterEntryMode';
import {
   canonicalWriteScopeSelection,
   isWritableMapping as mappingCanWrite,
   normalizeMapping
} from '../../../components/forms/FieldPropertyEditor/writeScope';
import {
   CopyIcon,
   DateFormItemIcon,
   DeleteIcon,
   NumberFormItemIcon,
   OptionsFormItemIcon,
   PhotoFormItemIcon,
   RepeaterFormItemIcon,
   SectionFormItemIcon,
   TextFormItemIcon,
   ToDoFormItemIcon,
   CalculatedFormItemIcon,
   LookupIcon,
   TextIcon
} from '../../../components/icons';
import FileResourceList from '../../../components/resources/FileResourceList';

const {
   fieldRequiredTypes,
   formItemTypes,
   optionsFormItemDisplayTypes,
   repeaterFormItemTypes,
   datetimeFormItemTypes,
   bindingTypes,
   writeScopes
} = constants;

const { classifyRepeaterEntryMode } = domain;
const { kinds: repeaterEntryModeKinds, entryModes: repeaterEntryModes } = classifyRepeaterEntryMode;

const decimalPlacesList = [{ id: 0, name: 'None' }, { id: 1, name: '1' }, { id: 2, name: '2' }, , { id: 3, name: '3' }];
const blankOptionsBinding = { noDataSource: null, idField: 'id', txtField: 'txt' };

const tabStates = {
   PROPS: 1,
   GUIDANCE: 2,
   LOGIC: 3
};

class FieldPropertyEditor extends Component {
   constructor(props) {
      super(props);

      this.captionRef = React.createRef();

      this.state = this.buildFromProps(props);

      this.stateRenders = {};
      this.stateRenders[tabStates.PROPS] = this.renderProps.bind(this);
      this.stateRenders[tabStates.GUIDANCE] = this.renderGuidance.bind(this);
      this.stateRenders[tabStates.LOGIC] = this.renderLogic.bind(this);
   }

   buildFromProps(props, s = {}) {
      let selectedItem = props.selectedItem ? { ...props.selectedItem } : null;

      return _.merge(
         {
            currentItem: selectedItem,
            broadcast: false,
            valid: false,
            shouldValidate: true,
            validations: {},
            highlight: false,
            editingOptions: false,
            editingList: false,
            datasourceAvailable: null,
            isDeleting: false,
            isUpgradingLegacyRepeater: false,
            tabState: tabStates.PROPS
         },
         s
      );
   }

   UNSAFE_componentWillReceiveProps(nextProps) {
      const currentItem = this.state.currentItem;
      const nextItem = nextProps.selectedItem;

      if (!nextItem || !_.isEqual(currentItem, nextItem)) {
         this.setState(this.buildFromProps(nextProps, { highlight: true }));
      }
   }

   componentDidUpdate() {
      const { shouldValidate, currentItem, broadcast, highlight } = this.state;
      if (shouldValidate) {
         var o = this.validate(currentItem);
         this.setState({ ...o, shouldValidate: false });
      }

      if (highlight) {
         if (this.captionRef.current) {
            if (this.captionRef.current.value && this.captionRef.current.value.length > 0) {
               this.captionRef.current.select();
            }
            this.captionRef.current.focus();
         }
         this.setState({ highlight: false });
      }

      if (broadcast) {
         const onChange = this.props.onChange;
         if (onChange) {
            onChange({ item: currentItem });
         }

         this.setState({ broadcast: false });
      }
   }

   _onFieldLabelChange = (e) => {
      const { currentItem } = this.state;

      currentItem['label'] = e.target.value;

      this.setState({ currentItem, broadcast: true });
   };

   _onFieldLabelPaste = (event) => {
      // Prevent the default paste behavior to capture the pasted text
      event.preventDefault();
      const onCopy = this.props.onCopy;

      // Get the pasted text from the clipboard
      const pastedText = event.clipboardData.getData('text');

      // Split the pasted text into lines
      let lines = pastedText.split('\n');
      lines = lines.filter((str) => str.trim() !== '');

      if (lines.length > 0) {
         // Ensure the first line becomes the current items value
         const { currentItem } = this.state;
         currentItem['label'] = lines[0];
         const newItem = { ...currentItem };
         this.setState({ newItem, broadcast: true }, () => {
            lines.shift();

            if (lines.length > 0) {
               if (onCopy) {
                  // Copy them across in reverse order so it maintains
                  // the order in the list.
                  for (var i = lines.length - 1; i >= 0; i--) {
                     (function (line) {
                        var a = { item: { ...newItem, label: line } };

                        setTimeout(() => {
                           onCopy(a);
                        }, 10);
                     })(lines[i]);
                  }
               }
            }
         });
      }
   };

   _onFieldHintChange = (e) => {
      const { currentItem } = this.state;

      currentItem['hint'] = e.target.value;

      this.setState({ currentItem, broadcast: true });
   };

   validate(currentItem) {
      let valid = false;
      let validations = {};
      let o = { ...currentItem };

      try {
         //cast(p, [types.email, types.name, types.password, types.confirm]);

         valid = true;
      } catch (err) {
         validations = _.isObject(err.message)
            ? err.asJSON
               ? err.message
               : JSON.stringify(err.message)
            : err.asJSON
            ? JSON.parse(err.message)
            : err.message;

         valid = false;
      }

      return { valid, validations, currentItem };
   }

   _onMayRaiseIssuesChanged = ({ event }) => {
      const mayRaiseIssues = event.target.checked;

      const { currentItem } = this.state;

      currentItem['mayRaiseIssues'] = mayRaiseIssues;

      this.setState({ currentItem, broadcast: true });
   };

   _onMayBeSkippedChanged = ({ event }) => {
      const mayBeSkipped = event.target.checked;

      const { currentItem } = this.state;

      currentItem['idRequiredType'] = mayBeSkipped ? fieldRequiredTypes.SKIPABLE.id : fieldRequiredTypes.ALWAYS.id;

      this.setState({ currentItem, broadcast: true });
   };

   _onAllowNotesChanged = ({ event }) => {
      const allowNotes = event.target.checked;

      const { currentItem } = this.state;

      currentItem['allowNotes'] = allowNotes;

      this.setState({ currentItem, broadcast: true });
   };

   _onEditRulesDone = ({ rules }) => {
      const { currentItem } = this.state;

      const clonedItem = { ...currentItem };

      clonedItem.options = clonedItem.options || {};

      clonedItem.options.rules = rules;

      this.setState({ currentItem: clonedItem, broadcast: true });
   };

   _onDataSourceChanged = ({ noDataSource }) => {
      const { currentItem } = this.state;

      let options = currentItem.options || {};
      currentItem['options'] = options;

      let binding = options && options.binding ? options.binding : _.cloneDeep(blankOptionsBinding);
      currentItem.options.binding = binding;
      binding.noDataSource = noDataSource;

      this.setState({ currentItem, broadcast: true });
   };

   _onAllowMultipleChanged = ({ currentItem, event }) => {
      const allowMultiple = event.target.checked;

      currentItem['options'] = currentItem.options || {};

      currentItem.options['allowMultiple'] = allowMultiple;

      this.setState({ currentItem, broadcast: true });
   };

   _onDateTimeTypeChanged = (event, value) => {
      const { currentItem } = this.state;

      currentItem['options'] = currentItem.options || {};

      const idDateTimeType = parseInt(value, 10);

      currentItem.options.idDateTimeType = idDateTimeType;

      this.setState({ currentItem, broadcast: true });
   };

   renderDateTimeProps() {
      const { currentItem, editingOptions } = this.state;
      const { options } = currentItem;
      let idDateTimeType = options ? options.idDateTimeType || datetimeFormItemTypes.DATE.id : datetimeFormItemTypes.DATE.id;

      return (
         <>
            <div className='d-flex justify-content-start flex-row align-items-center'>
               <span style={{ marginLeft: '8px', minWidth: '60px' }}>Capture</span>
               <RadioGroup
                  className='d-flex flex-row justify-content-center date-radio-group'
                  aria-label='customer type'
                  name='idDateTimeType'
                  value={idDateTimeType.toString()}
                  onChange={this._onDateTimeTypeChanged}>
                  <FormControlLabel value={datetimeFormItemTypes.DATE.id.toString()} control={<Radio color='primary' />} label={'Date'} />
                  <FormControlLabel value={datetimeFormItemTypes.TIME.id.toString()} control={<Radio color='primary' />} label={'Time'} />
                  <FormControlLabel
                     value={datetimeFormItemTypes.DATETIME.id.toString()}
                     control={<Radio color='primary' />}
                     label={'Date & Time'}
                  />
               </RadioGroup>
            </div>
         </>
      );
   }

   _onUseButtonsChanged = ({ currentItem, event }) => {
      const useButtons = event.target.checked;

      currentItem['options'] = currentItem.options || {};

      const idOptionsDisplayType = useButtons ? optionsFormItemDisplayTypes.BUTTONS.id : optionsFormItemDisplayTypes.BULLETS.id;

      currentItem.options.idOptionsDisplayType = idOptionsDisplayType;

      this.setState({ currentItem, broadcast: true });
   };

   renderOptionsProps() {
      const { currentItem, editingOptions } = this.state;
      const { availableLocations, availableTags } = this.props;
      const { options } = currentItem;
      let allowMultiple = options ? options.allowMultiple : false;
      let idOptionsDisplayType = options
         ? options.idOptionsDisplayType || optionsFormItemDisplayTypes.BULLETS.id
         : optionsFormItemDisplayTypes.BULLETS.id;
      let binding = options && options.binding ? options.binding : _.cloneDeep(blankOptionsBinding);
      const noDataSource = binding.noDataSource;

      let allowButtons = idOptionsDisplayType == optionsFormItemDisplayTypes.BUTTONS.id;

      return (
         <div className='options'>
            <div className='options-from'>
               <span style={{ marginLeft: '8px', minWidth: '60px' }}>Options from</span>
               <FieldDataSourceEditor
                  noDataSource={noDataSource}
                  onChange={this._onDataSourceChanged}
                  availableLocations={availableLocations}
                  availableTags={availableTags}
               />
            </div>
            <>
               <div className='d-flex justify-content-start flex-row align-items-center'>
                  <div>
                     <Checkbox
                        checked={allowButtons}
                        style={{ paddingBottom: 4, paddingTop: 4 }}
                        onChange={(e) => this._onUseButtonsChanged({ currentItem, event: e })}
                     />
                     Show options as buttons
                  </div>
               </div>
            </>
            <>
               <div className='d-flex justify-content-start flex-row align-items-center'>
                  <div>
                     <Checkbox
                        checked={allowMultiple}
                        style={{ paddingBottom: 4, paddingTop: 4 }}
                        onChange={(e) => this._onAllowMultipleChanged({ currentItem, event: e })}
                     />
                     Allow multiple answers
                  </div>
               </div>
            </>
         </div>
      );
   }

   renderRepeaterProps() {
      const { currentItem, datasourceAvailable } = this.state;
      const { availableLocations, availableTags } = this.props;

      const options = currentItem.options || {};
      const idRepeaterType = options.idRepeaterType;
      const binding = options.binding || { noDataSource: null };
      const noDataSource = binding.noDataSource;
      const classification = classifyRepeaterEntryMode({
         idRepeaterType: options.idRepeaterType,
         entryMode: options.entryMode,
         idRepeaterCadence: options.idRepeaterCadence,
         timesToRepeat: options.timesToRepeat
      });

      const isList = idRepeaterType == repeaterFormItemTypes.LIST.id;
      const isFreeFlow = idRepeaterType == repeaterFormItemTypes.FREE_FLOW.id;
      const isLegacy = classification.kind === repeaterEntryModeKinds.LEGACY_FOREACH;
      const isMalformed = classification.kind === repeaterEntryModeKinds.MALFORMED;
      const effectiveEntryMode = classification.effectiveEntryMode;
      const fullListAvailable = canUseFullListForOptions(options, datasourceAvailable);
      const typeValue = isList || isFreeFlow ? idRepeaterType.toString() : '';

      return (
         <div className='repeater-options'>
            <div className='repeater-option-row'>
               <span className='repeater-option-label'>Type</span>
               <RadioGroup
                  className='d-flex flex-row'
                  aria-label='Repeater type'
                  name='idRepeaterType'
                  value={typeValue}
                  onChange={this._onRepeaterTypeChanged}>
                  <FormControlLabel value={repeaterFormItemTypes.LIST.id.toString()} control={<Radio color='primary' />} label={'List'} />
                  <FormControlLabel
                     value={repeaterFormItemTypes.FREE_FLOW.id.toString()}
                     control={<Radio color='primary' />}
                     label={'Free flow'}
                  />
               </RadioGroup>
            </div>

            {isList && (
               <div className='data-source-editor-row repeater-option-row'>
                  <span className='repeater-option-label'>List from</span>
                  <FieldDataSourceEditor
                     noDataSource={noDataSource}
                     onChange={this._onDataSourceChanged}
                     onAvailabilityChange={this._onDataSourceAvailabilityChanged}
                     availableLocations={availableLocations}
                     availableTags={availableTags}
                  />
               </div>
            )}

            {isList && isLegacy && (
               <div className='repeater-entry-mode-status'>
                  <strong>Legacy entry behavior</strong>
                  <div>Entry count must match the resolved list size. Entries are not automatically created or fixed to source items.</div>
                  <Button size='small' color='primary' onClick={this._onLegacyUpgradeToFullList} disabled={!fullListAvailable}>
                     Upgrade to Full list
                  </Button>
                  <Button size='small' color='primary' onClick={this._onRepairAsAddEntries}>
                     Change to Add entries
                  </Button>
               </div>
            )}

            {isMalformed && (
               <div className='repeater-entry-mode-status'>
                  <strong>Entry mode configuration invalid</strong>
                  <div>
                     Type: {String(options.idRepeaterType)} · {classification.malformedReasonCode}
                  </div>
                  {isList && (
                     <>
                        <Button size='small' color='primary' onClick={this._onRepairAsAddEntries}>
                           Repair as Add entries
                        </Button>
                        <Button size='small' color='primary' onClick={this._onRepairAsFullList} disabled={!fullListAvailable}>
                           Repair as Full list
                        </Button>
                     </>
                  )}
                  {isFreeFlow && (
                     <Button size='small' color='primary' onClick={this._onRepairAsFreeFlow}>
                        Repair as Free flow
                     </Button>
                  )}
                  {!isList && !isFreeFlow && <div>Select List or Free flow to repair this Repeater.</div>}
               </div>
            )}

            {isList && !isLegacy && !isMalformed && (
               <>
                  <div className='repeater-option-row'>
                     <span className='repeater-option-label'>Entry mode</span>
                     <RadioGroup
                        className='d-flex flex-row'
                        aria-label='Repeater entry mode'
                        name='entryMode'
                        value={effectiveEntryMode || ''}
                        onChange={this._onEntryModeChanged}>
                        <FormControlLabel value={repeaterEntryModes.ADD_ENTRIES} control={<Radio color='primary' />} label='Add entries' />
                        <FormControlLabel
                           value={repeaterEntryModes.FULL_LIST}
                           control={<Radio color='primary' />}
                           label='Full list'
                           disabled={!fullListAvailable && effectiveEntryMode !== repeaterEntryModes.FULL_LIST}
                        />
                     </RadioGroup>
                  </div>

                  <div className='repeater-option-row repeater-requires-row'>
                     <span className='repeater-option-label'>Requires</span>
                     {effectiveEntryMode === repeaterEntryModes.FULL_LIST ? (
                        <span>
                           {datasourceAvailable === false
                              ? 'Cannot determine required items until the datasource is available'
                              : 'Every item available from the selected datasource'}
                        </span>
                     ) : (
                        <RepeatTimesSelector
                           onChange={this._repeatTimesChange}
                           idRepeaterType={idRepeaterType}
                           idRepeaterCadence={options.idRepeaterCadence}
                           timesToRepeat={options.timesToRepeat}
                        />
                     )}
                  </div>
               </>
            )}

            {isFreeFlow && !isMalformed && (
               <div className='repeater-option-row repeater-requires-row'>
                  <span className='repeater-option-label'>Requires</span>
                  <RepeatTimesSelector
                     onChange={this._repeatTimesChange}
                     idRepeaterType={idRepeaterType}
                     idRepeaterCadence={options.idRepeaterCadence}
                     timesToRepeat={options.timesToRepeat}
                  />
               </div>
            )}
         </div>
      );
   }

   _onDataSourceAvailabilityChanged = ({ available }) => {
      if (this.state.datasourceAvailable !== available) {
         this.setState({ datasourceAvailable: available });
      }
   };

   _repeatTimesChange = (d) => {
      const { currentItem } = this.state;
      const options = currentItem.options || {};
      const isFreeFlow = options.idRepeaterType == repeaterFormItemTypes.FREE_FLOW.id;
      let nextOptions = options;

      if (isFreeFlow) {
         if (options.idRepeaterCadence == d.idRepeaterCadence && options.timesToRepeat === d.timesToRepeat) return;
         nextOptions = { ...options, idRepeaterCadence: d.idRepeaterCadence, timesToRepeat: d.timesToRepeat };
         delete nextOptions.entryMode;
      } else {
         nextOptions = applyRequiresChange(options, d);
      }

      if (nextOptions === options) return;
      const nextItem = { ...currentItem, options: nextOptions };
      this.setState({ currentItem: nextItem, broadcast: true });
   };

   _onEntryModeChanged = (event, value) => {
      const { currentItem } = this.state;
      const options = currentItem.options || {};
      const classification = classifyRepeaterEntryMode({
         idRepeaterType: options.idRepeaterType,
         entryMode: options.entryMode,
         idRepeaterCadence: options.idRepeaterCadence,
         timesToRepeat: options.timesToRepeat
      });
      const nextOptions = applyEntryModeChange(options, value, classification.effectiveEntryMode);
      if (nextOptions === options) return;

      const nextItem = { ...currentItem, options: nextOptions };
      this.setState({ currentItem: nextItem, broadcast: true });
   };

   _onRepairAsAddEntries = () => {
      const { currentItem } = this.state;
      const options = currentItem.options || {};
      const nextOptions = applyEntryModeChange(options, repeaterEntryModes.ADD_ENTRIES, null);
      const nextItem = { ...currentItem, options: nextOptions };
      this.setState({ currentItem: nextItem, broadcast: true });
   };

   _onRepairAsFullList = () => {
      const { currentItem, datasourceAvailable } = this.state;
      const options = currentItem.options || {};
      if (!canUseFullListForOptions(options, datasourceAvailable)) return;

      const nextOptions = applyEntryModeChange(options, repeaterEntryModes.FULL_LIST, null);
      const nextItem = { ...currentItem, options: nextOptions };
      this.setState({ currentItem: nextItem, broadcast: true });
   };

   _onRepairAsFreeFlow = () => {
      const { currentItem } = this.state;
      const options = currentItem.options || {};
      const nextOptions = repairAsFreeFlow(options);
      const nextItem = { ...currentItem, options: nextOptions };
      this.setState({ currentItem: nextItem, datasourceAvailable: null, broadcast: true });
   };

   _onLegacyUpgradeToFullList = () => {
      this.setState({ isUpgradingLegacyRepeater: true });
   };

   _onLegacyUpgradeToFullListConfirmed = () => {
      this.setState({ isUpgradingLegacyRepeater: false }, this._onRepairAsFullList);
   };

   _onLegacyUpgradeToFullListCancelled = () => {
      this.setState({ isUpgradingLegacyRepeater: false });
   };

   _onRepeaterTypeChanged = (event, value) => {
      const { currentItem } = this.state;
      const idRepeaterType = parseInt(value, 10);
      const options = currentItem.options || {};
      const nextOptions = applyRepeaterTypeChange(options, idRepeaterType);
      if (nextOptions === options) return;

      const nextItem = { ...currentItem, options: nextOptions };
      this.setState({ currentItem: nextItem, datasourceAvailable: null, broadcast: true });
   };

   _normalizePrefix = (prefix) => {
      // New shape already
      if (prefix && typeof prefix === 'object' && 'type' in prefix) return prefix;

      // Old shape: null/string -> treat as text
      return { type: 'text', value: prefix ?? null };
   };

   _onPrefixTypeToggle = () => {
      const { currentItem } = this.state;

      currentItem.options = currentItem.options || {};

      const prefixObj = this._normalizePrefix(currentItem.options.prefix);

      if (prefixObj.type === 'text') {
         prefixObj.type = 'lookup';
         prefixObj.value = null;
      } else {
         prefixObj.type = 'text';
         prefixObj.value = null;
      }

      currentItem.options.prefix = prefixObj;

      this.setState({ currentItem, broadcast: true });
   };

   _onFieldPrefixChange = (e) => {
      const { currentItem } = this.state;

      currentItem.options = currentItem.options || {};

      const prefixObj = this._normalizePrefix(currentItem.options.prefix);
      const rawValue = e.target.value;
      prefixObj.value = rawValue === '' ? null : rawValue;

      currentItem.options.prefix = prefixObj;

      this.setState({ currentItem, broadcast: true });
   };

   _normalizeSuffix = (suffix) => {
      // New shape already
      if (suffix && typeof suffix === 'object' && 'type' in suffix) return suffix;

      // Old shape: null/string -> treat as text
      return { type: 'text', value: suffix ?? null };
   };

   _onSuffixTypeToggle = () => {
      const { currentItem } = this.state;

      currentItem.options = currentItem.options || {};

      const suffixObj = this._normalizeSuffix(currentItem.options.suffix);

      if (suffixObj.type === 'text') {
         suffixObj.type = 'lookup';
         suffixObj.value = null;
      } else {
         suffixObj.type = 'text';
         suffixObj.value = null;
      }

      currentItem.options.suffix = suffixObj;

      this.setState({ currentItem, broadcast: true });
   };

   _onFieldSuffixChange = (e) => {
      const { currentItem } = this.state;

      currentItem.options = currentItem.options || {};

      const suffixObj = this._normalizeSuffix(currentItem.options.suffix);

      const rawValue = e.target.value;
      suffixObj.value = rawValue === '' ? null : rawValue;

      currentItem.options.suffix = suffixObj;

      this.setState({ currentItem, broadcast: true });
   };

   _normalizePlaceholder = (placeholder) => {
      if (placeholder && typeof placeholder === 'object' && 'type' in placeholder) return placeholder;
      return { type: 'text', value: null };
   };

   _syncPlaceholderFromMapping = (options) => {
      if (typeof options.placeholder == 'undefined') {
         return options;
      }

      options.mapping = options.mapping || { type: 'none' };

      options.placeholder = this._normalizePlaceholder(options.placeholder);

      const mapping = this._normalizeMapping(options.mapping);

      const isLookupMapping = mapping.type === 'lookup';
      const isReadable = mapping.noBindingType === bindingTypes.READ.id || mapping.noBindingType === bindingTypes.READWRITE.id;

      const hasColumn = mapping.valueColumn != null && mapping.valueColumn !== '';

      if (isLookupMapping && isReadable && hasColumn) {
         options.placeholder = { type: 'lookup', value: mapping.valueColumn };
      } else {
         options.placeholder = { type: 'text', value: null };
      }

      // keep mapping normalized too
      options.mapping = mapping;

      return options;
   };

   _normalizeCalculated = (calculated) => {
      // already new shape
      if (calculated && typeof calculated === 'object' && calculated.type) {
         return {
            type: calculated.type || 'none',
            valueColumn: typeof calculated.valueColumn === 'undefined' ? null : calculated.valueColumn,
            noBindingType: typeof calculated.noBindingType === 'undefined' ? bindingTypes.READ.id : calculated.noBindingType
         };
      }

      // default
      return { type: 'none' };
   };

   _normalizeMapping = (mapping) => normalizeMapping(mapping);

   _onCalculatedTypeChange = (e) => {
      const { currentItem } = this.state;
      const nextType = e.target.value;

      currentItem.options = currentItem.options || {};

      if (nextType === 'none') {
         currentItem.options.calculated = { type: 'none' };
      } else {
         const existing = this._normalizeCalculated(currentItem.options.calculated);
         currentItem.options.calculated = {
            type: 'lookup',
            valueColumn: existing.valueColumn ?? null,
            noBindingType: existing.noBindingType ?? bindingTypes.READ.id
         };
      }

      this.setState({ currentItem, broadcast: true });
   };

   _onMappingTypeChange = (e) => {
      const { currentItem } = this.state;
      const nextType = e.target.value;

      currentItem.options = currentItem.options || {};

      if (nextType === 'none') {
         currentItem.options.mapping = { type: 'none' };
      } else {
         const existing = this._normalizeMapping(currentItem.options.mapping);
         currentItem.options.mapping = {
            type: 'lookup',
            valueColumn: existing.valueColumn ?? null,
            noBindingType: existing.noBindingType ?? bindingTypes.READ.id,
            writeScope: existing.writeScope
         };
      }

      // keep placeholder in sync
      currentItem.options = this._syncPlaceholderFromMapping(currentItem.options);

      this.setState({ currentItem, broadcast: true });
   };

   _onMappingBindingTypeChange = (e) => {
      const { currentItem } = this.state;

      currentItem.options = currentItem.options || {};
      const mapping = this._normalizeMapping(currentItem.options.mapping);

      mapping.noBindingType = parseInt(e.target.value, 10);
      currentItem.options.mapping = mapping;

      // keep placeholder in sync
      currentItem.options = this._syncPlaceholderFromMapping(currentItem.options);

      this.setState({ currentItem, broadcast: true });
   };

   _onCalculatedValueColumnChange = (e) => {
      const { currentItem } = this.state;

      currentItem.options = currentItem.options || {};
      const calculated = this._normalizeCalculated(currentItem.options.calculated);

      const raw = e.target.value;
      calculated.valueColumn = raw === '' ? null : raw;

      currentItem.options.calculated = calculated;

      this.setState({ currentItem, broadcast: true });
   };

   _onMappingWriteScopeChange = (e) => {
      const { currentItem } = this.state;
      const writeScope = canonicalWriteScopeSelection(e.target.value);
      if (!writeScope) return;

      currentItem.options = currentItem.options || {};
      const mapping = this._normalizeMapping(currentItem.options.mapping);
      mapping.writeScope = writeScope;
      currentItem.options.mapping = mapping;

      this.setState({ currentItem, broadcast: true });
   };

   _onMappingValueColumnChange = (e) => {
      const { currentItem } = this.state;

      currentItem.options = currentItem.options || {};
      const mapping = this._normalizeMapping(currentItem.options.mapping);

      const raw = e.target.value;
      mapping.valueColumn = raw === '' ? null : raw;

      currentItem.options.mapping = mapping;

      // keep placeholder in sync (this is the “hook in on any change”)
      currentItem.options = this._syncPlaceholderFromMapping(currentItem.options);

      this.setState({ currentItem, broadcast: true });
   };

   _onFieldPlacesChange = (event) => {
      const { currentItem } = this.state;

      const places = parseInt(event.target.value, 10);

      currentItem['options'] = currentItem.options || {};

      currentItem.options.numericality = currentItem.options.numericality ? currentItem.options.numericality : {};
      currentItem.options.numericality.places = places;

      this.setState({ currentItem, broadcast: true });
   };

   renderCalculatedProps() {
      const { currentItem } = this.state;
      const { options } = currentItem;

      const calculated = this._normalizeCalculated(options ? options.calculated : null);
      const isCalculatedLookup = calculated.type === 'lookup';

      return (
         <Fragment>
            {/* Data Binding */}
            <div
               style={{
                  position: 'relative',
                  border: '1px solid rgba(0,0,0,0.12)',
                  borderRadius: 6,
                  padding: '8px 16px 8px 16px',
                  marginTop: 12,
                  marginBottom: 6
               }}>
               <div
                  style={{
                     position: 'absolute',
                     top: -10,
                     left: 6,
                     padding: '0 8px',
                     background: '#fff',
                     fontSize: 14,
                     color: 'rgba(0,0,0,0.6)'
                  }}>
                  Mode
               </div>

               <RadioGroup value={calculated.type || 'none'} onChange={this._onCalculatedTypeChange}>
                  <FormControlLabel value='lookup' control={<Radio size='small' />} label='Lookup' style={{ marginBottom: 4 }} />
               </RadioGroup>

               {isCalculatedLookup && (
                  <div style={{ marginLeft: 32, marginTop: 0 }}>
                     <div
                        style={{
                           display: 'grid',
                           gridTemplateColumns: 'max-content 1fr',
                           gap: 16,
                           minWidth: 0
                        }}>
                        <TextField
                           label='Column'
                           value={calculated.valueColumn ?? ''}
                           onChange={this._onCalculatedValueColumnChange}
                           margin='dense'
                           variant='outlined'
                           fullWidth
                        />
                     </div>
                  </div>
               )}
            </div>
         </Fragment>
      );
   }

   renderNumberProps() {
      const { currentItem } = this.state;
      const { options } = currentItem;

      let numericality = options ? options.numericality || {} : {};
      let places = typeof numericality.places !== 'undefined' ? parseInt(numericality.places, 10) : 0;

      const prefixObj = this._normalizePrefix(options ? options.prefix : null);
      const isPrefixLookup = prefixObj.type === 'lookup';
      const tooltipPrefixText = isPrefixLookup
         ? 'Switch to text prefix'
         : 'Switch to a lookup on this column. This only works if nested in a repeater';

      const suffixObj = this._normalizeSuffix(options ? options.suffix : null);
      const isSuffixLookup = suffixObj.type === 'lookup';
      const tooltipSuffixText = isSuffixLookup
         ? 'Switch to text suffix'
         : 'Switch to a lookup on this column. This only works if nested in a repeater';

      const mapping = this._normalizeMapping(options ? options.mapping : null);
      const isMappingLookup = mapping.type === 'lookup';
      const isWritableMapping = mappingCanWrite(mapping);

      return (
         <Fragment>
            <div className='d-flex justify-content-start flex-row'>
               <TextField
                  id='field-prefix'
                  label='prefix'
                  margin='dense'
                  placeholder='eg £'
                  InputLabelProps={{ shrink: true }}
                  value={prefixObj.value ?? ''}
                  onChange={(e) => this._onFieldPrefixChange(e)}
                  InputProps={{
                     endAdornment: (
                        <InputAdornment position='end'>
                           <Tooltip title={tooltipPrefixText} arrow placement='top'>
                              <IconButton edge='end' onClick={this._onPrefixTypeToggle}>
                                 {isPrefixLookup ? <LookupIcon /> : <TextIcon />}
                              </IconButton>
                           </Tooltip>
                        </InputAdornment>
                     )
                  }}
                  variant='outlined'
               />
               <span className='answer-block'>Answer</span>
               <TextField
                  id='field-suffix'
                  label='suffix'
                  placeholder='eg °C'
                  InputLabelProps={{ shrink: true }}
                  margin='dense'
                  value={suffixObj.value ?? ''}
                  onChange={(e) => this._onFieldSuffixChange(e)}
                  InputProps={{
                     endAdornment: (
                        <InputAdornment position='end'>
                           <Tooltip title={tooltipSuffixText} arrow placement='top'>
                              <IconButton edge='end' onClick={this._onSuffixTypeToggle}>
                                 {isSuffixLookup ? <LookupIcon /> : <TextIcon />}
                              </IconButton>
                           </Tooltip>
                        </InputAdornment>
                     )
                  }}
                  variant='outlined'
               />
            </div>
            <TextField
               id='field-places'
               select
               label={'decimals'}
               value={places}
               onChange={(e) => this._onFieldPlacesChange(e)}
               SelectProps={{ native: true }}
               margin='dense'
               variant='outlined'
               className='select-places'>
               {decimalPlacesList.map((option) => (
                  <option key={'places-opt-' + option.id} value={option.id}>
                     {option.name}
                  </option>
               ))}
            </TextField>
            {/* Data Binding */}
            <div
               style={{
                  position: 'relative',
                  border: '1px solid rgba(0,0,0,0.12)',
                  borderRadius: 6,
                  padding: '8px 16px 8px 16px',
                  marginTop: 12,
                  marginBottom: 6
               }}>
               <div
                  style={{
                     position: 'absolute',
                     top: -10,
                     left: 6,
                     padding: '0 8px',
                     background: '#fff',
                     fontSize: 14,
                     color: 'rgba(0,0,0,0.6)'
                  }}>
                  Mode
               </div>

               <RadioGroup value={mapping.type || 'none'} onChange={this._onMappingTypeChange}>
                  <FormControlLabel value='none' control={<Radio size='small' />} label='Normal' style={{ marginBottom: 4 }} />
                  <FormControlLabel value='lookup' control={<Radio size='small' />} label='Lookup' style={{ marginBottom: 4 }} />
               </RadioGroup>

               {isMappingLookup && (
                  <div style={{ marginLeft: 32, marginTop: 0 }}>
                     <div
                        style={{
                           display: 'grid',
                           gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
                           gap: 16,
                           minWidth: 0
                        }}>
                        <TextField
                           select
                           label='Type'
                           value={mapping.noBindingType ?? bindingTypes.READ.id}
                           onChange={this._onMappingBindingTypeChange}
                           SelectProps={{ native: true }}
                           margin='dense'
                           variant='outlined'
                           fullWidth>
                           {Object.values(bindingTypes).map((bt) => (
                              <option key={bt.id} value={bt.id}>
                                 {bt.name}
                              </option>
                           ))}
                        </TextField>

                        <TextField
                           label='Column'
                           value={mapping.valueColumn ?? ''}
                           onChange={this._onMappingValueColumnChange}
                           margin='dense'
                           variant='outlined'
                           fullWidth
                        />

                        {isWritableMapping && (
                           <div style={{ gridColumn: '1 / -1', minWidth: 0 }}>
                              <TextField
                                 select
                                 fullWidth
                                 label='Write scope'
                                 value={mapping.writeScope}
                                 onChange={this._onMappingWriteScopeChange}
                                 SelectProps={{ native: true }}
                                 margin='dense'
                                 variant='outlined'
                                 helperText={
                                    !canonicalWriteScopeSelection(mapping.writeScope)
                                       ? 'Unsupported write scope. Choose Location or Global to repair.'
                                       : mapping.writeScope === writeScopes.GLOBAL
                                         ? 'Writes for this mapping are shared across all locations.'
                                         : 'Writes for this mapping apply to the location where the task is completed.'
                                 }>
                                 {!canonicalWriteScopeSelection(mapping.writeScope) && (
                                    <option value={mapping.writeScope} disabled>{`Unsupported: ${mapping.writeScope}`}</option>
                                 )}
                                 <option value={writeScopes.LOCATION}>Location</option>
                                 <option value={writeScopes.GLOBAL}>Global</option>
                              </TextField>
                           </div>
                        )}
                     </div>
                  </div>
               )}
            </div>
         </Fragment>
      );
   }

   _onAllowVideoChanged = ({ currentItem, event }) => {
      currentItem['options'] = currentItem.options || {};

      currentItem.options.allowVideo = event.target.checked;

      this.setState({ currentItem, broadcast: true });
   };

   _onAllowLibraryChanged = ({ currentItem, event }) => {
      currentItem['options'] = currentItem.options || {};

      currentItem.options.allowLibrary = event.target.checked;

      this.setState({ currentItem, broadcast: true });
   };

   _onSubFormChanged = ({ currentItem, event }) => {
      currentItem['options'] = currentItem.options || {};

      currentItem.options.isSubform = event.target.checked;

      this.setState({ currentItem, broadcast: true });
   };

   renderPhotoProps() {
      const { currentItem } = this.state;

      const { options } = currentItem;
      let allowVideo = options ? options.allowVideo || false : false;
      let allowLibrary = options ? options.allowLibrary || false : false;

      return (
         <Fragment>
            <div className='d-flex justify-content-start flex-row align-items-center'>
               <Checkbox
                  style={{ paddingBottom: 4, paddingTop: 4 }}
                  checked={allowVideo}
                  onChange={(e) => this._onAllowVideoChanged({ currentItem, event: e })}
               />
               Allow videos
            </div>
            <div className='d-flex justify-content-start flex-row align-items-center'>
               <Checkbox
                  style={{ paddingBottom: 4, paddingTop: 4 }}
                  checked={allowLibrary}
                  onChange={(e) => this._onAllowLibraryChanged({ currentItem, event: e })}
               />
               Allow uploads from device's media library
            </div>
         </Fragment>
      );
   }

   renderSectionProps() {
      const { currentItem } = this.state;

      const { options } = currentItem;
      let isSubform = options ? options.isSubform || false : false;
      let lockedSubForm = options ? options.isSubformLocked || false : false;
      let lockedCaption = lockedSubForm
         ? 'Remove the nested sections within this section to change this.'
         : isSubform
         ? 'Displays in its own page, unselect to display inline'
         : 'Displays inline, select to display in its own page';

      return (
         <Fragment>
            <div className='d-flex justify-content-start flex-row align-items-center'>
               <Tooltip title={lockedCaption} placement='right'>
                  <div>
                     <Checkbox
                        disabled={lockedSubForm}
                        style={{ paddingTop: 4, paddingBottom: 4 }}
                        checked={isSubform}
                        onChange={(e) => this._onSubFormChanged({ currentItem, event: e })}
                     />
                     Displays in its own page
                  </div>
               </Tooltip>
            </div>
         </Fragment>
      );
   }

   renderSpecificType({ idItemType }) {
      switch (idItemType) {
         case formItemTypes.OPTIONS.id:
            return this.renderOptionsProps();

         case formItemTypes.NUMBER.id:
            return this.renderNumberProps();

         case formItemTypes.DATETIME.id:
            return this.renderDateTimeProps();

         case formItemTypes.PHOTO.id:
            return this.renderPhotoProps();

         case formItemTypes.CALCULATED.id:
            return this.renderCalculatedProps();

         case formItemTypes.SECTION.id:
            return this.renderSectionProps();

         case formItemTypes.REPEATER.id:
            return this.renderRepeaterProps();

         default:
            return null;
      }
   }

   renderIcon(idItemType) {
      switch (idItemType) {
         case formItemTypes.TODO.id:
            return <ToDoFormItemIcon />;

         case formItemTypes.OPTIONS.id:
            return <OptionsFormItemIcon />;

         case formItemTypes.NUMBER.id:
            return <NumberFormItemIcon />;

         case formItemTypes.TEXT.id:
            return <TextFormItemIcon />;

         case formItemTypes.PHOTO.id:
            return <PhotoFormItemIcon />;

         case formItemTypes.DATETIME.id:
            return <DateFormItemIcon />;

         case formItemTypes.CALCULATED.id:
            return <CalculatedFormItemIcon />;
         case formItemTypes.SECTION.id:
            return <SectionFormItemIcon />;

         case formItemTypes.REPEATER.id:
            return <RepeaterFormItemIcon />;

         default:
            return null;
      }
   }

   _onDeleteRequested = () => {
      this.setState({ isDeleting: true });
   };

   _onDeleteConfirmed = () => {
      const { currentItem } = this.state;

      const onDelete = this.props.onDelete;
      if (onDelete) {
         onDelete({ item: currentItem });
      }

      this.setState({ isDeleting: false });
   };

   _onDeleteCancelled = () => {
      this.setState({ isDeleting: false });
   };

   _onCopyClicked = () => {
      const { currentItem } = this.state;

      const onCopy = this.props.onCopy;
      if (onCopy) {
         onCopy({ item: currentItem });
      }
   };

   renderProps() {
      const { currentItem } = this.state;
      const itemData = currentItem || {};
      const { label = '', idItemType, idRequiredType, allowNotes = false, mayRaiseIssues = false } = itemData;

      const isSkippable = idRequiredType === fieldRequiredTypes.SKIPABLE.id;

      const renderCheckboxOption = ({ label, style = {}, checked, onChange, tooltip }) => (
         <div className='d-flex justify-content-start flex-row align-items-center'>
            {tooltip ? (
               <Tooltip title={tooltip}>
                  <div>
                     <Checkbox checked={checked} style={style} onChange={onChange} />
                     <span>{label}</span>
                  </div>
               </Tooltip>
            ) : (
               <div>
                  <Checkbox checked={checked} style={style} onChange={onChange} />
                  <span>{label}</span>
               </div>
            )}
         </div>
      );

      return (
         <div className='d-flex justify-content-start flex-column'>
            {/* Label Field with Icon */}
            <div className='d-flex justify-content-start align-items-center flex-row'>
               <TextField
                  id='field-label'
                  label='Caption'
                  placeholder='Start typing...'
                  margin='normal'
                  variant='outlined'
                  style={{ marginLeft: 10, flex: 1 }}
                  value={label}
                  onChange={(e) => this._onFieldLabelChange(e)}
                  onPaste={this._onFieldLabelPaste}
                  inputRef={this.captionRef}
                  InputProps={{
                     startAdornment: (
                        <InputAdornment position='start'>
                           {this.renderIcon(idItemType)}
                           <Divider style={{ height: 28, margin: 4 }} orientation='vertical' />
                        </InputAdornment>
                     )
                  }}
               />

               {/* Action Buttons */}
               {currentItem && (
                  <div>
                     <Tooltip title='Remove this item'>
                        <IconButton className='btn-delete' edge='end' onClick={() => this._onDeleteRequested()}>
                           <DeleteIcon />
                        </IconButton>
                     </Tooltip>
                     <Tooltip title='Clone this item'>
                        <IconButton className='btn-copy' edge='end' onClick={() => this._onCopyClicked()}>
                           <CopyIcon />
                        </IconButton>
                     </Tooltip>
                  </div>
               )}
            </div>

            <Divider style={{ margin: 4 }} />

            {/* Item Type Specific UI */}
            {this.renderSpecificType({ idItemType })}

            {/* Configuration Options */}
            {renderCheckboxOption({
               label: 'May be skipped',
               style: { paddingBottom: 4, paddingTop: 4 },
               checked: isSkippable,
               onChange: (e) => this._onMayBeSkippedChanged({ event: e }),
               tooltip: isSkippable ? 'unselect to make this question mandatory' : 'select to make this question optional'
            })}

            {renderCheckboxOption({
               label: 'Allow notes',
               style: { paddingBottom: 4, paddingTop: 4 },
               checked: allowNotes,
               onChange: (e) => this._onAllowNotesChanged({ event: e })
            })}

            {/* Uncomment to enable issue raising */}
            {/* {renderCheckboxOption({
               label: 'Allow raising issues',
               checked: mayRaiseIssues,
               onChange: (e) => this._onMayRaiseIssuesChanged({ event: e }),
               tooltip: mayRaiseIssues
                  ? 'unselect to disallow raising issues'
                  : 'select to allow raising issues',
            })} */}
         </div>
      );
   }

   _onResourceListChanged = ({ resources }) => {
      const { currentItem } = this.state;

      currentItem['resources'] = resources;

      this.setState({ currentItem, broadcast: true });
   };

   renderLogic() {
      const { currentItem } = this.state;

      let options = currentItem.options || {};

      let binding = options && options.binding ? options.binding : _.cloneDeep(blankOptionsBinding);
      const noDataSource = binding.noDataSource;

      if (noDataSource == null) {
         return <></>;
      }

      let rules = currentItem.options.rules || [];

      return (
         <>
            <DataSourceRulesEditor rules={rules} onChange={this._onEditRulesDone} />
         </>
      );
   }

   renderGuidance() {
      const { currentItem } = this.state;
      const { availableLocations, availableTags } = this.props;

      let itemData = currentItem || {};

      const { hint, resources } = itemData;

      let hintVal = hint || '';

      return (
         <div className='d-flex justify-content-start flex-column'>
            <TextField
               autoFocus={true}
               id='field-hint'
               InputLabelProps={{ shrink: true }}
               label='Instructions'
               placeholder={'eg. explain how to complete...'}
               margin='normal'
               value={hintVal}
               onChange={(e) => this._onFieldHintChange(e)}
               variant='outlined'
            />
            <FileResourceList
               minNoAttachments={0}
               resources={resources}
               availableLocations={availableLocations}
               availableTags={availableTags}
               readOnly={false}
               onChange={this._onResourceListChanged}
               addBlankRow={false}
            />
         </div>
      );
   }

   _onTabChange = (event, value) => {
      this.setState({ tabState: value });
   };

   renderForState(tabState) {
      return <div className='prop-window'>{this.stateRenders[tabState]()}</div>;
   }

   renderTabs() {
      const { tabState, currentItem } = this.state;
      let itemData = currentItem || {};
      const { idItemType } = itemData;

      const tabClasses = 'tabs-bar';
      const showLogic = idItemType === formItemTypes.OPTIONS.id;

      return (
         <Fragment>
            <Tabs
               className={tabClasses}
               scrollButtons='on'
               indicatorColor='primary'
               textColor='primary'
               value={tabState}
               onChange={this._onTabChange}>
               <Tab value={tabStates.PROPS} className='tab' label='Setup' />
               <Tab value={tabStates.GUIDANCE} className='tab' label='Instructions' />
               {showLogic && <Tab value={tabStates.LOGIC} className='tab' label='Logic' />}
            </Tabs>
         </Fragment>
      );
   }

   render() {
      const { currentItem, isDeleting, isUpgradingLegacyRepeater, tabState } = this.state;
      let itemData = currentItem || {};

      const { label, hint, idRequiredType, idItemType } = itemData;

      return (
         <div className='FieldPropertyEditor'>
            {!currentItem && <span></span>}

            {currentItem && this.renderForState(tabState)}
            {currentItem && this.renderTabs()}
            {isDeleting && (
               <SweetAlert
                  show={true}
                  warning
                  showCancel
                  confirmBtnText={'Yes'}
                  cancelBtnText={'No'}
                  confirmBtnBsStyle='warning'
                  cancelBtnBsStyle='default'
                  title={'Remove Field?'}
                  onConfirm={this._onDeleteConfirmed}
                  onCancel={this._onDeleteCancelled}>
                  <Typography>Are you sure you want to remove this field</Typography>
               </SweetAlert>
            )}
            {isUpgradingLegacyRepeater && (
               <SweetAlert
                  show={true}
                  warning
                  showCancel
                  confirmBtnText={'Upgrade'}
                  cancelBtnText={'Cancel'}
                  confirmBtnBsStyle='warning'
                  cancelBtnBsStyle='default'
                  title={'Upgrade to Full list?'}
                  onConfirm={this._onLegacyUpgradeToFullListConfirmed}
                  onCancel={this._onLegacyUpgradeToFullListCancelled}>
                  <Typography>
                     Full list automatically represents every resolved datasource item and replaces the legacy count-only behavior. This change applies to newly generated tasks.
                  </Typography>
               </SweetAlert>
            )}
         </div>
      );
   }
}

FieldPropertyEditor.defaultProps = {
   onChange: ({ item }) => {},
   onDelete: ({ item }) => {},
   onCopy: ({ item }) => {},
   selectedItem: null,
   availableLocations: [],
   availableTags: []
};

FieldPropertyEditor.propTypes = {};

export default FieldPropertyEditor;
